import React, { useEffect } from "react";
import {
  FaUserPlus,
  FaUserCheck,
  FaUserTimes,
  FaLink,
  FaTrash,
  FaFlag,
} from "react-icons/fa";
import frnds from "../assets/frnds.png";
import ellipse from "../assets/Ellipse 1.png";
import pipaanlogo from "../assets/pipaanlogo.svg";
import newsfeed from "../assets/images/icons/newsfeed.png";
import friendsfollowers from "../assets/images/icons/friendsandfollowers.png";
import groupsandfamily from "../assets/images/icons/groupandfamily.png";
import chats from "../assets/images/icons/chats.png";
import profile from "../assets/images/icons/profile.png";
import Account from "../assets/images/icons/account-setting.png";
import help from "../assets/images/icons/helpandsupport.png";
import logout from "../assets/images/icons/logout.png";
import GroupsList from "../components/nestedtab/GroupsList";
import Verify from "../assets/images/icons/verify.png";
import backtogrp from "../assets/images/icons/backtogrp.png";
import verifybadge from "../assets/images/icons/verify.svg";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar"; // Import scrollbar styles
import {
  FaBell,
  FaCommentAlt,
  FaHeart,
  FaShare,
  FaSearch,
  FaChevronDown,
} from "react-icons/fa";
import groupimg from "../assets/groupimg.png";
import userimg from "../assets/user.png";
import profileimg from "../assets/profile.png";
import share from "../assets/share.png";
import notification from "../assets/images/icons/notification.png";
import hamburger from "../assets/images/icons/hamburger.png";
import hamburgerclose from "../assets/images/icons/hamburgerclose.png";
import closecircle from "../assets/images/icons/close-circle.png";
import FeedPost from "./feedpost/FeedPost";
import postData from "./feedpost/postdata";
import { Menu, X, Bell, User } from "lucide-react"; // Icons
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaTimes } from "react-icons/fa";
import { useState } from "react";
import profilebanner from "../assets/images/Profile-banner.png";
import Leftsidebar from "../components/sidebar/leftsidebar";
import LeftResponsivesidebar from "../components/sidebar/left-responsive";
import Rightsidebar from "../components/sidebar/rightsidebar";
import RightResponsivesidebar from "../components/sidebar/right-responsive";
import Headmenu from "../components/sidebar/headmenu";
import profileData from "./feedpost/profiledata";
import postone from "../assets/images/post-1.png";
import posttwo from "../assets/images/post-2.png";
import postthree from "../assets/images/post-3.png";
// import GroupTabs from "../components/nestedtab/GroupTabs";
import groupone from "../assets/images/group-1.png";
import grouptwo from "../assets/images/group-2.png";
import groupthree from "../assets/images/group-3.png";
import groupfour from "../assets/images/group-4.png";
import Grpaddcircle from "../assets/images/icons/grp-add-circle.png";
import { friendRequests, groupData } from "./nestedtab/friendRequestsData";
import { Check } from "lucide-react"; // Icon library for the check mark
import axios from "axios";
import { loadFriendRequests } from "../components/nestedtab/friendRequestsData"; // Import the function to load friend requests
import Adminpanel from "../components/nestedtab/adminpanel";
import Microphone from "../assets/images/icons/microphone.png";
import Smiley from "../assets/images/icons/Smiley.svg";
import videoicon from "../assets/images/icons/video.svg";
import galleryicon from "../assets/images/icons/gallery.svg";
import searchicon from "../assets/images/icons/search.png";
import { addFamily } from "../api/addFamily"; // adjust the path as needed
import imageCompression from "browser-image-compression";
import { useRef } from "react";
import { io } from "socket.io-client";
import EmojiPicker from "emoji-picker-react";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");
const GroupTabs = ({
  user,
  groupData,
  onGroupDelete,
  fgroupData,
  showDashboard,
  setShowDashboard,
  onViewGroupInfo,
}) => {
  const [activeTab, setActiveTab] = useState("Groupchat");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [images, setImages] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [groupSearch, setGroupSearch] = useState("");
  const [socket, setSocket] = useState(null);
  const [messages, setMessages] = useState([]);
  const saved = localStorage.getItem("groupMessages");
  const [sentMessages, setSentMessages] = useState(
    saved ? JSON.parse(saved) : []
  );
  const [message, setMessage] = useState("");
  const [connected, setConnected] = useState(false);

  const messagesEndRef = useRef(null);
  const [userEmail, setUserEmail] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [hoveredMsgIndex, setHoveredMsgIndex] = useState(null);
  const [menuOpenIndex, setMenuOpenIndex] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [isVideoRecording, setIsVideoRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const [videoChunks, setVideoChunks] = useState([]);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [coverUrl, setCoverUrl] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

      try {
        const response = await fetch(
          `${API_BASE_URL}/user/profile`,
          {
            method: "GET",
            headers: {
              token: `${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          console.error("❌ API Error Data:", errorData);
          return;
        }

        const data = await response.json();
        // console.log("✅ API Success:", data);
        setCoverUrl(data.result.profile_picture_url);
        setCurrentUser(data.result);
      } catch (err) {
        console.error("❌ Fetch Error:", err);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchUserProfile = async () => {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

      if (!token) {
        console.warn("Token not found");
        return;
      }

      try {
        const response = await fetch(
          `${API_BASE_URL}/user/profile`,
          {
            method: "GET",
            headers: {
              token: `${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();

        if (response.ok && data.result) {
          setUserEmail(data.result);
        } else {
          console.error("Profile fetch error:", data.message);
        }
      } catch (err) {
        console.error("Network error fetching profile:", err);
      }
    };

    fetchUserProfile();
  }, []);

  const USER = {
    id: user?.id, // Use the current user's id
    token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
    name: user?.name || "User",
  };

  const API_URL =
    `${API_BASE_URL}/group_chat/add-group_chat`;
  const SOCKET_URL = `${API_ORIGIN}/`;

  useEffect(() => {
    const newSocket = io(SOCKET_URL, {
      auth: { token: USER.token },
    });

    newSocket.on("connect", () => {
      setConnected(true);
      newSocket.emit("join", USER.id);
    });
    newSocket.on("joined", (message) => {
      // console.log("Room join confirmation:", message);
    });
    newSocket.on("receive-message", (msg) => {
      setMessages((prev) => [
        ...prev,
        {
          ...msg,
          timestamp: msg.timestamp || new Date().toISOString(),
        },
      ]);
    });

    newSocket.on("disconnect", () => setConnected(false));
    setSocket(newSocket);

    return () => {
      newSocket.off("receive-message");
      newSocket.close();
    };
  }, [USER.id, USER.token]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, sentMessages]);
  // Filter group data based on user.id
  const allGroup = [...groupData];
  const selectedGroup = allGroup.find((group) => group.id === user?.id);

  useEffect(() => {
    if (user && user.id) {
      // console.log(`User ID: ${user.id}`);
    }
  }, [user]);

  // Join this group's chat room so this member actually receives messages
  // other members send (the server already broadcasts to "group_<id>", but
  // nothing was subscribing the client to that room before).
  useEffect(() => {
    if (socket && selectedGroup?.id) {
      socket.emit("join-group", selectedGroup.id);
    }
  }, [socket, selectedGroup?.id]);

  // Return early if no group data matches the condition
  if (!selectedGroup && selectedGroup)
    return <p className="text-center text-red-500">No Group Data Found</p>;
  // if (!selectedGroup) {
  //   return <p className="text-center text-red-500">Group not found for the user.</p>;
  // }

  const sendMessage = async () => {
    if (!message.trim()) return;

    const payload = {
      message: message,
      reciever_id: "22",
      media_url: [],
      is_group_chat: true,
    };

    try {
      const response = await axios.post(API_URL, payload, {
        headers: {
          Token: USER.token,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        const newMsg = {
          message: message,
          group_id: selectedGroup.id,
          sender_id: USER.id,
          timestamp: new Date().toISOString(),
          sender_name: userEmail.first_name,
        };

        const updatedMessages = [...sentMessages, newMsg];
        setSentMessages(updatedMessages);

        localStorage.setItem("groupMessages", JSON.stringify(updatedMessages));

        setMessage("");

        if (response.data && response.data.new_field) {
          window.location.reload(); // hard reload
        }
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const handleDeleteMessage = (keyToDelete) => {
    const deletedKeys = JSON.parse(
      localStorage.getItem("deletedMsgKeys") || "[]"
    );
    const updatedKeys = [...deletedKeys, keyToDelete];
    localStorage.setItem("deletedMsgKeys", JSON.stringify(updatedKeys));

    const updatedMsgs = messages.filter((msg) => msg.timestamp !== keyToDelete);
    const updatedSentMsgs = sentMessages.filter(
      (msg) => msg.timestamp !== keyToDelete
    );

    setMessages(updatedMsgs);
    setSentMessages(updatedSentMsgs);
  };

  // Image Upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      sendFileMessage(file, "image");
      e.target.value = ""; // Clear for next upload
    }
  };

  // Voice Recording
  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mediaRecorder = new MediaRecorder(stream);
    const chunks = [];
    mediaRecorderRef.current = mediaRecorder;

    mediaRecorder.ondataavailable = (e) => chunks.push(e.data);
    mediaRecorder.onstop = () => {
      const blob = new Blob(chunks, { type: "audio/webm" });
      sendFileMessage(blob, "audio");
      stream.getTracks().forEach((track) => track.stop());
    };

    mediaRecorder.start();
    setIsRecording(true);
  };

  const stopRecording = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state !== "inactive"
    ) {
      mediaRecorderRef.current.stop();
    }
  };

  // Video Recording
  const startVideoRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    const mediaRecorder = new MediaRecorder(stream);
    const chunks = [];
    mediaRecorderRef.current = mediaRecorder;

    mediaRecorder.ondataavailable = (e) => chunks.push(e.data);
    mediaRecorder.onstop = () => {
      const blob = new Blob(chunks, { type: "video/webm" });
      sendFileMessage(blob, "video");
      stream.getTracks().forEach((track) => track.stop());
    };

    mediaRecorder.start();
    setIsVideoRecording(true);
  };

  const stopVideoRecording = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state !== "inactive"
    ) {
      mediaRecorderRef.current.stop();
    }
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  // Send media or file message
  const sendFileMessage = async (file, type = "image") => {
    try {
      const base64File = await fileToBase64(file);

      const payload = {
        message: "", // optional message
        reciever_id: selectedGroup?.id, // ✅ same as your text messages
        is_group_chat: true,
        media_base64: base64File, // ✅ base64 file
        media_type: type, // optional: "image", "video", "audio"
      };

      const formData = new FormData();
      formData.append("file", file);
      formData.append("message", "");
      formData.append("reciever_id", user.id);
      formData.append("reciever_id", selectedGroup?.id);
      formData.append("is_group_chat", "true");

      for (const [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      // Debug logs
      console.log("Sending media:");
      for (const [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const response = await axios.post(
        `${API_BASE_URL}/group_chat/add-group_chat`,
        formData,
        {
          headers: {
            Token: USER.token,
          },
        }
      );

      console.log("API success response:", response.data);

      if (response?.data?.success) {
        const msg = response.data.result;
        const newMsg = {
          ...msg,
          type: type,
          file: msg.media_url?.[0] || "", // or however backend gives the file URL
          sender_id: USER.id,
          sender_name: userEmail.first_name,
          timestamp: new Date().toISOString(),
        };

        setSentMessages((prev) => {
          const updated = [...prev, newMsg];
          localStorage.setItem("groupMessages", JSON.stringify(updated));
          return updated;
        });
      }
    } catch (err) {
      console.error("Error details:", err);
      if (err.response) {
        console.error("API Response Error:", err.response.data);
        alert(`API Error: ${err.response.data.message || "Unknown error"}`);
      } else if (err.request) {
        console.error("No response received:", err.request);
        alert("No response from server. Please check your connection.");
      } else {
        console.error("Unexpected error:", err.message);
        alert(`Unexpected Error: ${err.message}`);
      }
    }
  };

  const deletedKeys = JSON.parse(
    localStorage.getItem("deletedMsgKeys") || "[]"
  );

  return (
    <div className="p-4 bg-gray-100 rounded-2xl shadow-md my-6 adminpanel">
      {/* Header with Tab Switching */}

      {activeTab === "Groupchat" && (
        <div>
          {/* CHAT HEADER */}
          <div className="chat-header flex items-center p-4 bg-white border-b">
            <img
              src={selectedGroup?.group_image || userimg}
              alt={selectedGroup?.group_name}
              className="w-20 h-20 rounded-[16px] mr-3"
            />

            <div className="flex-1 text-center">
              <h2 className="head text-[#2C2C2E] flex justify-center items-center">
                &#129412; {selectedGroup?.group_name}
              </h2>
              <p className="text-[12px] text-[#666668]">
                {selectedGroup?.acceptedMembersCount} Members | Created on:{" "}
                {new Date(selectedGroup?.created_at).toLocaleDateString()}
              </p>

              <span
                onClick={() => {
                  setActiveTab("Adminpanel");
                  setSelectedUserId(user.id);
                  onViewGroupInfo?.(); // hide tab list
                  setShowDashboard?.(false); // hide dashboard
                }}
                className="text-[#095228] text-sm cursor-pointer underline"
              >
                View Group Info
              </span>
            </div>
            <div className="hidden md:block">
              <div className="flex items-center bg-[#F3F4F6] px-3 py-4 rounded-full grp-chat-search-field ">
                <img src={searchicon} className="w-auto mr-3" />
                <input
                  type="text"
                  placeholder="Find Message"
                  className="ml-2 text-gray-500 outline-none bg-transparent w-full hidden md:block"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="sm:hidden">
              <div>
                {/* Toggle Button */}
                <button
                  className="px-3"
                  onClick={() => setShowSearch(!showSearch)}
                >
                  <img src={searchicon} alt="Video Icon" />
                </button>

                {/* Search Field */}
                {showSearch && (
                  <div className="flex items-center bg-[#F0F0F0] px-3 py-4 rounded-full grp-chat-search-field">
                    <img src={searchicon} className="w-auto searchicon" />
                    <input
                      type="text"
                      placeholder="Find Message"
                      className="ml-2 text-gray-500 outline-none bg-transparent w-full"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* CHAT CONTENT AREA */}
          {showDashboard !== false && (
            <div className="dashboard w-full min-h-screen flex mx-auto">
              <main className="flex w-full">
                <div className="flex flex-col h-full w-full">
                  <div className="flex-1 p-4 overflow-y-auto space-y-3">
                    {currentUser &&
                      [...messages, ...sentMessages]
                        .filter((msg) => msg.group_id === selectedGroup?.id)
                        .map((msg, i) => ({ ...msg, _localIndex: i }))
                        .filter((msg) => !deletedKeys.includes(msg.timestamp))
                        .sort(
                          (a, b) =>
                            new Date(a.timestamp) - new Date(b.timestamp)
                        )
                        .map((msg, index) => {
                          const msgText = msg.message || msg.text || "";
                          const matchIndex =
                            msgText && searchTerm
                              ? msgText
                                .toLowerCase()
                                .indexOf(searchTerm.toLowerCase())
                              : -1;

                          // If search term exists in the message
                          const hasMatch = searchTerm && matchIndex !== -1;

                          let highlightedMessage;

                          if (hasMatch) {
                            const before = msgText.slice(0, matchIndex);
                            const match = msgText.slice(
                              matchIndex,
                              matchIndex + searchTerm.length
                            );
                            const after = msgText.slice(
                              matchIndex + searchTerm.length
                            );

                            highlightedMessage = (
                              <span>
                                {before}
                                <span className="bg-yellow-200 font-semibold">
                                  {match}
                                </span>
                                {after}
                              </span>
                            );
                          }
                          // console.log(currentUser.first_name, "currentUser.first_name");
                          // console.log(msg.sender_name, "msg.sender_name");
                          return (
                            <div
                              key={index}
                              className={`flex ${currentUser.first_name === msg.sender_name
                                ? "justify-end"
                                : "justify-start"
                                }`}
                              onMouseEnter={() => setHoveredMsgIndex(index)}
                              onMouseLeave={() => {
                                setHoveredMsgIndex(null);
                                setMenuOpenIndex(null);
                              }}
                            >
                              <div
                                className={`relative max-w-xs p-3 rounded-2xl shadow ${currentUser.first_name === msg.sender_name
                                  ? "bg-[#095228] text-white"
                                  : "bg-white text-black"
                                  }`}
                                style={{
                                  position: "relative",
                                  minWidth: "150px",
                                }}
                              >
                                {/* Render highlighted message if match found */}
                                {msg.type === "image" ? (
                                  <img
                                    src={msg.file}
                                    alt="sent-img"
                                    className="w-40 rounded-lg"
                                  />
                                ) : msg.type === "audio" ? (
                                  <audio
                                    controls
                                    src={msg.file}
                                    className="w-full"
                                  />
                                ) : msg.type === "video" ? (
                                  <video
                                    controls
                                    src={msg.file}
                                    className="w-40 rounded-lg"
                                  />
                                ) : (
                                  <span>
                                    {hasMatch
                                      ? highlightedMessage
                                      : msgText || "[No text]"}
                                  </span>
                                )}

                                <div
                                  className="text-right pr-2 w-max"
                                  style={{ fontSize: "8px" }}
                                >
                                  <p>{msg.sender_name || "No Name"}</p>
                                </div>
                                <div className="text-[10px] text-right mt-1 text-gray-400">
                                  {msg.timestamp &&
                                    new Date(msg.timestamp).toLocaleTimeString(
                                      [],
                                      {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      }
                                    )}
                                </div>
                                {/* 3 Dots icon (visible on hover) */}
                                {hoveredMsgIndex === index &&
                                  msg.sender_id === USER.id && (
                                    <button
                                      onClick={() =>
                                        setMenuOpenIndex(
                                          menuOpenIndex === index ? null : index
                                        )
                                      }
                                      className="absolute top-1 right-2 text-gray-300"
                                    >
                                      &#8942;
                                    </button>
                                  )}
                                {/* Dropdown menu */}
                                {menuOpenIndex === index && (
                                  <div className="absolute top-6 right-2 bg-white shadow-md border rounded-md z-10">
                                    <button
                                      onClick={() =>
                                        handleDeleteMessage(msg.timestamp)
                                      }
                                      className="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100 w-full text-left"
                                    >
                                      Delete
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    <div ref={messagesEndRef} />
                  </div>

                  {/* CHAT FOOTER (INPUT AREA) */}

                  <div className="flex items-center p-4 chat-footer-input">
                    <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
                      <label className="relative cursor-pointer">
                        <img
                          src={coverUrl}
                          alt={selectedGroup?.groupName}
                          className="w-[80px] h-[40px] rounded-full object-cover"
                        />
                      </label>
                    </div>

                    <div className="flex items-center rounded-[20px] border border-[#B4B7C9] bg-white w-full">
                      {/* Microphone (Voice) */}
                      <div className="flex space-x-2 ml-3 py-4 microphone-sm">
                        <button
                          onClick={isRecording ? stopRecording : startRecording}
                          className="text-gray-400"
                        >
                          <img src={Microphone} alt="Mic" />
                        </button>
                      </div>

                      {/* Text Input */}
                      <input
                        type="text"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                        placeholder="Type your message..."
                        className="flex-1 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none bg-[#f8f9fa]"
                      />

                      {/* Media Icons */}
                      <div className="flex space-x-2 ml-3 py-4 chat-media-icon">
                        <button
                          className="px-3 smiley"
                          onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                        >
                          <img src={Smiley} alt="Smiley" />
                        </button>

                        {/* Image Upload */}
                        <label className="cursor-pointer">
                          <img src={galleryicon} alt="Gallery" />
                          <input
                            type="file"
                            multiple
                            accept="image/*"
                            className="hidden"
                            onChange={handleImageUpload}
                          />
                        </label>

                        {/* Video Recording */}
                        <button
                          className="px-3"
                          onClick={
                            isVideoRecording
                              ? stopVideoRecording
                              : startVideoRecording
                          }
                        >
                          <img src={videoicon} alt="Video" />
                        </button>
                      </div>

                      {/* Send Button */}
                      <button
                        onClick={sendMessage}
                        disabled={
                          !connected || (!message.trim() && !selectedFile)
                        }
                        className="mx-2 bg-[#095228] text-white px-5 py-3 h-full rounded-[25px]"
                      >
                        Send
                      </button>
                    </div>
                  </div>
                </div>
              </main>
            </div>
          )}
        </div>
      )}

      {showEmojiPicker && (
        <div className="absolute bottom-20 z-50">
          <EmojiPicker
            onEmojiClick={(emojiData) => {
              setMessage((prev) => prev + emojiData.emoji);
              setShowEmojiPicker(false); // close after selecting
            }}
          />
        </div>
      )}

      {/* Admin Panel */}
      {activeTab === "Adminpanel" && (
        <Adminpanel
          matchedGroup={selectedGroup}
          onGroupDelete={onGroupDelete}
          setShowDashboard={setShowDashboard}
          setActiveTab={setActiveTab}
        />
      )}

      {/* Back Button for Returning to Groupchat */}
      {activeTab === "Adminpanel" && (
        <div className="p-2 text-center">
          <button
            onClick={() => {
              setActiveTab("Groupchat");
              setShowDashboard?.(true); // ✅ Add this line
            }}
            className="text-blue-500 text-sm underline"
          >
            Back to Group Chat
          </button>
        </div>
      )}
    </div>
  );
};

const friends = [
  { id: 1, name: "Websters Shivaji", followers: 764, img: ellipse },
  { id: 2, name: "Websters Shivaji", followers: 764, img: ellipse },
  { id: 3, name: "Websters Shivaji", followers: 764, img: ellipse },
];

const user = {
  img: "https://example.com/group-image.jpg",
  name: "Team Unicorns",
  followers: 200,
  followerImages: [
    "https://example.com/follower1.jpg",
    "https://example.com/follower2.jpg",
  ],
};

export default function FriendsPage() {
  const [coverPhoto, setCoverPhoto] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [groupDescription, setGroupDescription] = useState("");
  const [groupImage, setGroupImage] = useState(null);
  const [groupCover, setGroupCover] = useState(null);
  const [groupMembers, setGroupMembers] = useState([]); // Array of user IDs
  const [loading, setLoading] = useState(false); // Loading state for the API call
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [error, setError] = useState(null); // Error state for file upload
  const [searchQuery, setSearchQuery] = useState(""); // Search query for friends
  const [followers, setFollowers] = useState([]); // List of fetched followers
  const [selectedFriends, setSelectedFriends] = useState([]); // Selected friends for the group
  const [hasMore, setHasMore] = useState(true); // To check if more data is available
  const [friendRequests, setFriendRequests] = useState([]);
  const [activeUser, setActiveUser] = useState(null);
  const [showTabs, setShowTabs] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);
  const [groupData, setGroupData] = useState([]); // Store groups from API
  const [fgroupData, setfGroupData] = useState([]);
  const [groupRequests, setGroupRequests] = useState([]);
  const [groupSearch, setGroupSearch] = useState("");
  const [familyData, setFamilyData] = useState([]); // All families
  const [familyRequests, setFamilyRequests] = useState([]); // If you have pending requests logic
  const [activeFamily, setActiveFamily] = useState(null);
  const [inviteFriends, setInviteFriends] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [profilePhotoBase64, setProfilePhotoBase64] = useState("");
  const [coverPhotoBase64, setCoverPhotoBase64] = useState("");
  const [familyFormData, setFamilyFormData] = useState({
    name: "",
    info: "",
  });
  const [selectedMemberIds, setSelectedMemberIds] = useState([]);
  const [showDashboard, setShowDashboard] = useState(true);

  const compressAndSetImage = async (file, setPreview, setBase64) => {
    const options = {
      maxSizeMB: 0.5, // Limit size to 0.5MB
      maxWidthOrHeight: 200,
      useWebWorker: true,
    };
    try {
      const compressedFile = await imageCompression(file, options);
      const base64 = await imageCompression.getDataUrlFromFile(compressedFile);
      setPreview(base64); // for preview
      setBase64(base64); // for API payload
    } catch (error) {
      console.error("Image compression failed:", error);
    }
  };

  const handleCoverPhotoChangeFamily = (e) => {
    const file = e.target.files[0];
    if (file) {
      compressAndSetImage(file, setCoverPhoto, setCoverPhotoBase64);
    }
  };

  const handleProfilePhotoChangeFamily = (e) => {
    const file = e.target.files[0];
    if (file) {
      compressAndSetImage(file, setProfilePhoto, setProfilePhotoBase64);
    }
  };

  const handleGroupDeleteFromList = (deletedGroupId) => {
    setGroupData((prev) => prev.filter((group) => group.id !== deletedGroupId));
  };

  useEffect(() => {
    const fetchGroupRequests = async () => {
      setLoading(true);
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // Replace with your token retrieval logic

      try {
        const response = await axios.post(
          `${API_BASE_URL}/group/get-groups`,
          {
            filters: {
              myPendingGroup: true,
              is_family_group: false,
            },
            page: 1,
            limit: 20,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: `${token}`,
            },
          }
        );

        if (response.data.success) {
          setGroupRequests(
            response.data.result.groups.filter(
              (group) => group?.is_deleted !== true
            )
          );
        } else {
          console.error(
            "Failed to fetch group requests:",
            response.data.message
          );
        }
      } catch (error) {
        console.error("Error fetching group requests:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGroupRequests();
  }, []);

  // 2. Move fetchGroups outside useEffect so you can call it manually
  const fetchGroups = async (search = "") => {
    setLoading(true);
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    const userId = sessionStorage.getItem("userID"); // Make sure userID is stored in sessionStorage

    try {
      const response = await axios.post(
        `${API_BASE_URL}/group/get-groups`,
        {
          filters: {
            myAcceptedGroup: true,
            search: search, // Add search key here
          },
          page: 1,
          limit: 50,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: `${token}`,
          },
        }
      );
      if (response.data.success) {
        setGroupData(
          response.data.result.groups.filter((group) => !group.is_deleted)
        );
      } else {
        console.error("Failed to fetch groups:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchFamilyGroups = async (search = "") => {
    setLoading(true);
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    const userId = sessionStorage.getItem("userID");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/group/get-groups`,
        {
          filters: {
            myAcceptedGroup: true,
            search: search,
          },
          page: 1,
          limit: 50,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: `${token}`,
          },
        }
      );

      if (response.data.success) {
        // Filter groups where is_family_group is true and not deleted
        const familyGroups = response.data.result.groups.filter(
          (group) => !group.is_deleted && group.is_family_group
        );
        setfGroupData(familyGroups);
      } else {
        console.error("Failed to fetch family groups:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching family groups:", error);
    } finally {
      setLoading(false);
    }
  };

  // Call fetchGroups on mount and when groupSearch changes
  useEffect(() => {
    fetchGroups(groupSearch);
  }, [groupSearch]);

  useEffect(() => {
    const fetchData = async () => {
      const requests = await loadFriendRequests();
      setFriendRequests(requests);
    };

    fetchData();
  }, []);

  const handleCoverPhotoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setCoverPhoto(URL.createObjectURL(file));
    }
  };

  const handleProfilePhotoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfilePhoto(URL.createObjectURL(file));
    }
  };
  const [isPopupOpen, CreatePopupOpen] = useState(false); // 🔹 Popup state
  const [isfamilyPopupOpen, CreatefamilyPopupOpen] = useState(false); // 🔹 Popup state
  const createnewgroup = () => {
    CreatePopupOpen(true);
  };
  const createnewfamily = () => {
    CreatefamilyPopupOpen(true);
  };
  const closePopup = () => {
    CreatePopupOpen(false);
    CreatefamilyPopupOpen(false);
  };

  // ✅ Define state properly
  const [isOpen, setIsOpen] = useState(false);

  // ✅ Separate function for toggling state
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };
  const [activeTab, setActiveTab] = useState("Groups");
  const friendsList = [1, 2, 3, 4]; // Replace with actual friends data
  const followersList = [1, 2, 3, 4, 5, 6]; // Replace with actual followers data

  const uploadFiles = async (uploadedMedia) => {
    if (uploadedMedia.length === 0)
      throw new Error("No files selected for upload");

    const fileData = uploadedMedia.map((media) => ({
      fileName: media.file.name,
      fileType: media.file.type,
    }));

    try {
      // Step 1: Generate pre-signed URLs
      const response = await axios.post(
        `${API_BASE_URL}/aws/generate-presigned-url`,
        { files: fileData },
        {
          headers: {
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          },
        }
      );

      if (!response.data.success) {
        throw new Error("Failed to generate pre-signed URLs");
      }

      const preSignedUrls = response.data.directory;

      // Step 2: Upload media files to S3
      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          await axios.put(item.presignedUrl, uploadedMedia[index].file, {
            headers: {
              "Content-Type": uploadedMedia[index].file.type,
              "Content-Encoding": "binary",
            },
          });
          console.log(`${item.fileName} uploaded successfully`);
        })
      );

      // Return the uploaded media URLs
      return preSignedUrls.map((item) => ({
        media_type: item.fileType.startsWith("image") ? "image" : "video",
        url: item.fileUrl,
      }));
    } catch (error) {
      console.error("Upload error:", error);
      throw new Error("Failed to upload files. Please try again.");
    }
  };

  // Handle group image upload
  const handleGroupImageUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const uploadedMedia = [
          { file, type: file.type.startsWith("image/") ? "image" : "video" },
        ];
        const uploadedUrls = await uploadFiles(uploadedMedia);
        setGroupImage(uploadedUrls[0].url); // Set the uploaded URL for the group image
      } catch (error) {
        console.error("Error uploading group image:", error);
        setError("Failed to upload group image. Please try again.");
      }
    }
  };

  // Handle group cover upload
  const handleGroupCoverUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const uploadedMedia = [
          { file, type: file.type.startsWith("image/") ? "image" : "video" },
        ];
        const uploadedUrls = await uploadFiles(uploadedMedia);
        setGroupCover(uploadedUrls[0].url); // Set the uploaded URL for the group cover
      } catch (error) {
        console.error("Error uploading group cover:", error);
        setError("Failed to upload group cover. Please try again.");
      }
    }
  };

  const handleCreateGroup = async () => {
    // Only validate groupName and groupDescription (not images)
    if (!groupName.trim() || !groupDescription.trim()) {
      alert("Please enter both Group Name and Group Info.");
      return;
    }

    setLoading(true); // Set loading state

    try {
      const response = await axios.post(
        `${API_BASE_URL}/group/add-group`,
        {
          group_name: groupName,
          group_image: groupImage,
          group_cover: groupCover,
          description: groupDescription,
          group_members: groupMembers, // Array of user IDs
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.data.success) {
        alert("Group created successfully!");
        // Reset the form
        setGroupName("");
        setGroupDescription("");
        setGroupImage(null);
        setGroupCover(null);
        setGroupMembers([]);
        fetchGroups(); // <-- Refresh groups list after creation
        fetchFamilyGroups();

        CreatePopupOpen(false); // Close the popup
      } else {
        console.error("Failed to create group:", response.data.message);
        alert("Failed to create group.");
      }
    } catch (error) {
      console.error("Error creating group:", error);
      alert("An error occurred while creating the group.");
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const fetchFollowers = async (query = "", page = 1) => {
    setLoading(true);
    setError(null);

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    const requestBody = {
      filters: {
        isFriendsOnly: true,

        // search: query, // Add search query to filter results
      },
      page: page,
      limit: 10,
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/user/get-all-users`,
        requestBody,
        {
          headers: {
            token: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        const newFollowers = response.data.result.users;

        // Append new followers to the existing list
        setFollowers((prev) =>
          page === 1 ? newFollowers : [...prev, ...newFollowers]
        );

        // Check if there are more followers to load
        if (newFollowers.length < 10) {
          setHasMore(false); // No more data if fewer than 10 items are returned
        }
      } else {
        setError("Failed to fetch followers.");
      }
    } catch (error) {
      console.error("❌ Error fetching followers:", error);
      setError("An error occurred while fetching followers.");
    } finally {
      setLoading(false);
    }
  };
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim() !== "") {
      fetchFollowers(query); // Fetch followers matching the query
    } else {
      setFollowers([]); // Clear followers if the query is empty
    }
  };
  const handleFriendSelect = (friend) => {
    if (!selectedFriends.some((f) => f.id === friend.id)) {
      setSelectedFriends((prev) => [...prev, friend]);
      setGroupMembers((prev) => [...prev, friend.id]); // Add friend ID to groupMembers
    }
  };
  const handleGroupAction = async (groupId, action) => {
    // Show confirmation dialog
    const confirmMsg =
      action === "accept"
        ? "Are you sure you want to accept this group request?"
        : "Are you sure you want to reject this group request?";
    if (!window.confirm(confirmMsg)) return;

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // Replace with your token retrieval logic
    const userId = sessionStorage.getItem("userID"); // Retrieve the current user's ID (ensure it's stored in sessionStorage or similar)

    const status = action === "accept" ? "accepted" : "rejected";

    try {
      const response = await axios.post(
        `${API_BASE_URL}/group/update-member-status`,
        {
          group_id: groupId,
          user_id: userId,
          status: status,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: `${token}`,
          },
        }
      );

      if (response.data.success) {
        alert(
          status === "accepted"
            ? "Group request accepted successfully!"
            : "Group request rejected successfully!"
        );
        window.location.reload(); // Reload the page
      } else {
        alert("Failed to update group status: " + response.data.message);
      }
    } catch (error) {
      console.error("Error updating group status:", error);
    }
  };


  const filteredGroups = groupSearch.trim()
    ? groupData.filter(
      (group) =>
        !group.is_deleted &&
        !group.is_family_group &&
        group.group_name &&
        group.group_name.toLowerCase().includes(groupSearch.toLowerCase())
    )
    : groupData.filter((group) => !group.is_deleted && !group.is_family_group);

  const filteredFamily = groupSearch.trim()
    ? groupData.filter(
      (group) =>
        !group.is_deleted &&
        group.is_family_group &&
        group.group_name &&
        group.group_name.toLowerCase().includes(groupSearch.toLowerCase())
    )
    : groupData.filter((group) => !group.is_deleted && group.is_family_group);

  const fetchFamilyRequests = async () => {
    setLoading(true);
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/group/add-group`,
        {
          filters: {
            myPendingGroup: true,
            is_family_group: true, //family
          },
          page: 1,
          limit: 20,
        },
        {
          headers: {
            token: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        setFamilyRequests(response.data.result.groups); // Use separate state for families
      } else {
        console.error(
          "Failed to fetch family requests:",
          response.data.message
        );
      }
    } catch (error) {
      console.error("Error fetching family requests:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchFamilies = async (search = "") => {
    setLoading(true);
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/group/get-groups`,
        {
          filters: {
            myAcceptedGroup: true,
            is_family_group: true, // 👈 FAMILY
            search: search,
          },
          page: 1,
          limit: 50,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: `${token}`,
          },
        }
      );
      if (response.data.success) {
        setFamilyData(
          response.data.result.groups.filter((group) => !group.is_deleted)
        );
      } else {
        console.error("Failed to fetch families:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching families:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleCreateGroupOrFamily = async (isFamily = false) => {
    if (!groupName.trim() || !groupDescription.trim()) {
      alert("Please enter both Name and Info.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/group/add-group`,
        {
          group_name: groupName,
          group_image: groupImage,
          group_cover: groupCover,
          description: groupDescription,
          group_members: groupMembers,
          is_family_group: isFamily, // 👈 This toggles between group/family
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.data.success) {
        alert(`${isFamily ? "Family" : "Group"} created successfully!`);
        resetForm();
        isFamily ? fetchFamilies() : fetchGroups(); // Refresh respective list
        isFamily ? CreatefamilyPopupOpen(false) : CreatePopupOpen(false);
      } else {
        alert("Failed to create.");
      }
    } catch (error) {
      console.error("Creation error:", error);
      alert("An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFamilyFormData({}); // adjust to your form structure
    setActiveFamily(null); // or close modal, etc.
  };
  const handleFamilyDeleteFromList = (id) => {
    setFamilyData((prev) => prev.filter((fam) => fam.id !== id));
  };
  const FamilyTabs = ({ user, familyData, onFamilyDelete }) => {
    return (
      <div className="p-4 bg-white rounded shadow">
        <h2 className="text-xl font-semibold">{user?.family_name}</h2>
        {/* Add more detailed view here */}
        <button
          onClick={() => onFamilyDelete(user.id)}
          className="mt-4 text-red-600"
        >
          Delete Family
        </button>
      </div>
    );
  };

  const handleCreateFamily = async () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    const payload = {
      group_name: familyFormData.name,
      group_image: profilePhotoBase64?.slice(0, 250),
      group_cover: coverPhotoBase64?.slice(0, 250),
      description: familyFormData.info.slice(0, 254),
      group_members: selectedMemberIds, // should be an array of IDs
      is_family_group: true,
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/group/add-group`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: `${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        console.error("Server error:", data);
        alert(data.message || "Failed to create family group.");
        return;
      }

      alert("Family group created successfully!");

      // Set tab to "family" before reload
      localStorage.setItem("currentTab", "family");

      CreatefamilyPopupOpen(false); // close popup

      setTimeout(() => {
        window.location.reload(); // reload page to refresh data
      }, 300);
    } catch (error) {
      console.error("Network error:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  // console.log(filteredFamily, "filterfam");

  return (
    <div className="dashboard w-full min-h-screen flex ">
      {/* Sidebar */}
      <div className="h-full menu-bar-left">
        <Leftsidebar />
      </div>
      <main className="flex-1 p-5 pl-8 main-body">
        <LeftResponsivesidebar />
        <Headmenu />
        {/* Main Content */}
        <main className="flex ">
          {/* Feeds */}
          <div className="flex-1 space-y-6 sm:w-3/4 md:w-1/2 lg:w-1/3 xl:w-1/4">
            <div className="flex  space-x-4 mt-4">
              <div className="slider-md-swiper grp-slider-md-swiper">
                <aside className=" bg-white p-3  ">
                  <div className="">
                    {/* Followers Section */}
                    <h3 className="text-xl font-bold flex items-center pb-5">
                      Group Requests
                      <span className="tab-user-count ml-2 text-[#fff] bg-[#095228]">
                        {groupRequests.length}
                      </span>
                    </h3>
                    {groupRequests.length === 0 ? (
                      <div className="text-center text-gray-500 py-8">
                        You have no pending group requests.
                      </div>
                    ) : (
                      <Swiper
                        spaceBetween={10}
                        slidesPerView={3}
                        navigation={false}
                        scrollbar={{ hide: false, draggable: true }}
                        modules={[Scrollbar]}
                        breakpoints={{
                          0: { slidesPerView: 1 }, // 📱 Show 1 slide on small screens
                          768: { slidesPerView: 2 }, // 🖥 Show 2 slides on tablets
                          1024: { slidesPerView: 3 }, // 💻 Show 3 slides on desktops
                        }}
                        className="relative"
                      >
                        {groupRequests.map((user) => (
                          <SwiperSlide key={user.id}>
                            <div className="swiper-groupsfollowers bg-white flex items-center p-4 my-7 shadow-sm">
                              {/* Group Image */}
                              <img
                                src={user.group_image || userimg}
                                alt={user.group_name}
                                className="rounded-lg w-16 h-16 object-cover profile-grp"
                              />

                              <div className="flex swiper-groupsfollowers-sm">
                                {/* Group Details */}
                                <div className="ml-4 flex-1">
                                  {/* Group Name */}
                                  <h4 className="text-lg font-semibold px-1 rounded text-[#000000] truncate w-40 d-block">
                                    {user.group_name}
                                  </h4>

                                  {/* Member Avatars */}
                                  <div className="flex items-center justify-between">
                                    <div className="flex -space-x-1">
                                      {(user.followerImages ?? [])
                                        .slice(0, 4)
                                        .map((img, index) => (
                                          <img
                                            key={index}
                                            src={img}
                                            alt={`Follower ${index + 1}`}
                                            className="w-6 h-6 rounded-full border-2 border-white"
                                          />
                                        ))}
                                    </div>
                                    <p className="text-sm text-[#000000]">
                                      {user.acceptedMembersCount ?? "0"} Members
                                    </p>
                                    {/* Buttons */}
                                    <div className="flex items-center space-x-2 grp-swiper-cta">
                                      <button
                                        onClick={() =>
                                          handleGroupAction(user.id, "accept")
                                        }
                                        className="bg-[#095228] text-white px-4 py-2 rounded-full"
                                      >
                                        Accept
                                      </button>
                                      <button
                                        onClick={() =>
                                          handleGroupAction(user.id, "reject")
                                        }
                                        className="border-2 border-[#BE1F2E] text-[#BE1F2E] px-3 py-2 rounded-full flex items-center justify-center w-10 h-8 reject"
                                      >
                                        <span className="hidden sm:block">✖</span>
                                        <span className="md:hidden">Reject</span>
                                      </button>
                                    </div>
                                  </div>


                                </div>



                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    )}
                  </div>
                </aside>
              </div>
            </div>
            <div></div>

            <div className="feed-tabs profile-page-feeds w-full mx-auto text-center lg:text-left">
              <div className="flex items-center gap-x-6 justify-between">
                {/* Tabs */}
                <div className="filter bg-[] lg:p-3 flex space-x-4">
                  {["Groups", "Family"].map((tab) => (
                    <button
                      key={tab}
                      className={`lg:p-3 friends-flowers-tab flex ${activeTab === tab
                        ? "active focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                        : "text-black "
                        } focus:outline-none`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                      <span className="tab-user-count ml-1 text-[#fff] bg-[#095228]">
                        {tab === "Groups"
                          ? filteredGroups.length
                          : filteredFamily.length}
                      </span>
                    </button>
                  ))}
                </div>

                {/* Create New Group CTA (visible only when Groups tab is active) */}
                {activeTab === "Groups" && (
                  <div className="w-full flex items-center gap-4 justify-end">
                    <div className="flex justify-end hidden md:block text-end">
                      <button
                        class="grp-crt-new-grp text-[16px] h-full rounded-[25px] mx-3"
                        onClick={createnewgroup}
                      >
                        <div className="flex px-5 py-3 bg-[#ffffff9e] rounded-[25px]">
                          <img src={Grpaddcircle} className="w-7 h-6 pr-1" />
                          <span>Create New Group</span>
                        </div>
                      </button>
                    </div>
                  </div>
                )}

                {/* Create New Family CTA (visible only when Family tab is active) */}
                {activeTab === "Family" && (
                  <div className="w-full flex items-center gap-4 justify-end">
                    <div className="flex justify-end hidden md:block text-end">
                      <button
                        class="grp-crt-new-grp text-[16px] h-full rounded-[25px] mx-3"
                        onClick={createnewfamily}
                      >
                        <div className="flex px-5 py-3 bg-[#ffffff9e] rounded-[25px]">
                          <img src={Grpaddcircle} className="w-7 h-6 pr-1" />
                          <span>Create New Family</span>
                        </div>
                      </button>
                    </div>
                  </div>
                )}
              </div>
              {/* Tab Content */}
              <div className="mt-4">
                {activeTab === "Groups" && (
                  //  <GroupsList friendRequests={friendRequests} />
                  <div className="grp-tab-content grid">
                    {/* Group Tabs (Left Sidebar) */}
                    <div className="grp-tab-content-flex grid grid-cols-[auto_1fr] gap-2 ">
                      <div className="">
                        {(showTabs || !isMobile) && (
                          <div className="grop-tab">
                            <div className="flex relative w-full mt-6">
                              <div className="fasearch">
                                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" />
                              </div>
                              <input
                                type="text"
                                placeholder="Find Your Group"
                                className="search-input focus:outline-none focus:ring-2 focus:ring-gray-300 text-[#000]"
                                value={groupSearch}
                                onChange={(e) => setGroupSearch(e.target.value)}
                              />
                            </div>
                            <div className="w-full flex justify-end block md:hidden py-5">
                              <button
                                class="w-full grp-crt-new-grp text-[16px] h-full rounded-[25px] mx-0 "
                                onClick={createnewgroup}
                              >
                                <div className="w-full flex px-5 py-3 bg-[#ffffff9e] rounded-[25px]">
                                  <img
                                    src={Grpaddcircle}
                                    className="w-7 h-6 pr-1"
                                  />{" "}
                                  <span>Create New Group</span>
                                </div>
                              </button>
                            </div>
                            {isPopupOpen && (
                              <div className="popup-share z-[99999] viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
                                <div className="border-popup bg-white rounded-lg  relative">
                                  <div className="flex justify-between">
                                    <div className="logo-popup flex items-center justify-center space-x-2 ">
                                      <img
                                        src={pipaanlogo}
                                        alt="Pipaan Logo"
                                        className="w-50"
                                      />
                                    </div>
                                    {/* Close Button */}
                                    <button
                                      className="close-pop-x relative  text-gray-500"
                                      onClick={() => CreatePopupOpen(false)}
                                    >
                                      {" "}
                                      <img
                                        src={closecircle}
                                        alt="Pipaan Logo"
                                        className="w-10 h-10"
                                      />
                                    </button>
                                  </div>
                                  <div className="max-w-3xl mx-auto p-4 crt-new-grp">
                                    <div className="flex flex-col items-center space-y-4">
                                      {/* Cover Photo */}
                                      <div className="relative pb-[100px]">
                                        <div className="cover-photo-newgrp relative w-[500px] md:w-[750px] h-[200px] bg-green-100 overflow-hidden">
                                          {coverPhoto ? (
                                            <img
                                              src={coverPhoto}
                                              alt="Cover Preview"
                                              className="w-full h-full object-cover"
                                            />
                                          ) : (
                                            <div className="flex justify-center items-center w-full h-full text-gray-500">
                                              Upload Cover Photo
                                            </div>
                                          )}
                                          <input
                                            type="file"
                                            accept="image/*"
                                            className="absolute inset-0 w-full h-auto opacity-0 cursor-pointer"
                                            onChange={handleCoverPhotoChange}
                                          />
                                        </div>

                                        {/* Profile Photo */}
                                        <div className=" top:20px md:right-[auto] absolute top-[130px] left-[30px] w-[150px] h-[150px] bg-green-300 rounded-[42px] overflow-hidden">
                                          {profilePhoto ? (
                                            <img
                                              src={profilePhoto}
                                              alt="Profile Preview"
                                              className="w-full h-full object-cover"
                                            />
                                          ) : (
                                            <div className="flex justify-center items-center w-full h-full text-gray-500">
                                              Upload Profile
                                            </div>
                                          )}
                                          <input
                                            type="file"
                                            accept="image/*"
                                            className="absolute inset-0 w-auto h-auto opacity-0 cursor-pointer"
                                            onChange={handleProfilePhotoChange}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="mb-4 text-left">
                                      <label className="block text-[#000000] font-medium mb-2">
                                        Group Name
                                      </label>
                                      <input
                                        type="text"
                                        placeholder="Enter Group Name"
                                        className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                      />
                                    </div>

                                    <div className="mb-4 text-left">
                                      <label className="block text-[#000000] font-medium mb-2">
                                        Group Info
                                      </label>
                                      <textarea
                                        placeholder="Enter Group Name"
                                        className="w-full border border-[#095228] rounded-[12px] p-4 h-24 focus:outline-none focus:ring-2 focus:ring-green-500"
                                      />
                                    </div>
                                    <div className="mb-4 text-left">
                                      <label className="block text-[#000000] font-medium mb-2">
                                        Invite Friends
                                      </label>
                                      <input
                                        type="text"
                                        placeholder="Invite Friends"
                                        className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                      />
                                    </div>
                                    <div className=" followers followers-friends-profile followers-responsive justify-between flex-wrap md:flex-nowrap pb-6 border-b border-[#161f283d]">
                                      <div className="flex w-full items-center">
                                        <img
                                          src={userimg}
                                          alt="User"
                                          className="w-15 h-15 rounded-full"
                                        />
                                        <div className="pl-4 w-full">
                                          <div className="flex items-center justify-between">
                                            <p className="titlesemibold pb-1 pr-5">
                                              Marketing Group
                                            </p>
                                          </div>
                                          <p className="text-[12px] text-[#747474] pb-1">
                                            @prvnk_sky
                                          </p>
                                          <p className="members">
                                            764 Followers{" "}
                                            <span className="text-[#D9D9D9]">
                                              |
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                      <div className="flex items-center space-x-4 w-full  justify-between  flex-row-reverse  md:flex-row mt-3">
                                        {/* Custom Checkbox */}
                                        <label className="flex items-center space-x-2 cursor-pointer ">
                                          <div
                                            className={`w-4 h-4 border-2 rounded-md flex justify-center items-center transition ${isAdmin
                                              ? "border-[#095228] bg-green-100"
                                              : "border-gray-400"
                                              }`}
                                            onClick={() => setIsAdmin(!isAdmin)}
                                          >
                                            {isAdmin && (
                                              <Check
                                                size={18}
                                                className="text-[#095228]"
                                              />
                                            )}
                                          </div>
                                          <span className="text-[#344054] text-[12px]">
                                            Mark as Admin
                                          </span>
                                        </label>

                                        <div className="flex follow-unfollow-cta justify-end ">
                                          <button className="follow-cta my-2">
                                            Add as Group Member
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex relative w-full ">
                                      <div className="fasearch">
                                        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" />
                                      </div>
                                      <input
                                        type="text"
                                        placeholder="Find Group Members"
                                        className="search-input focus:outline-none focus:ring-2 focus:ring-[#e5e7eb] bg-[#FFFFFF]"
                                      />
                                    </div>
                                    <div className=" followers followers-friends-profile followers-responsive justify-between border-b-0 border-[#fff] pb-6 ">
                                      <div className="flex w-full">
                                        <img
                                          src={userimg}
                                          alt="User"
                                          className="w-15 h-15 rounded-full"
                                        />
                                        <div className="pl-4 w-full">
                                          <div className="flex items-center ">
                                            <p className="titlesemibold pb-1 pr-5">
                                              Marketing Group
                                            </p>
                                            <p className="cursor-pointer text-[10px] text-[#095228] mt-1 flex items-center">
                                              <img
                                                src={Verify}
                                                className="w-fit h-fit"
                                              />
                                              <span>Admin</span>
                                            </p>
                                          </div>
                                          <p className="text-[12px] text-[#747474] pb-1">
                                            @prvnk_sky
                                          </p>
                                          <p className="members">
                                            764 Followers{" "}
                                            <span className="text-[#D9D9D9] px-2">
                                              |
                                            </span>{" "}
                                            <span className="italic text-[#095228b8] text-[10px] underline">
                                              4 Mutual Followers
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                      <div className="flex follow-unfollow-cta justify-end w-full">
                                        <button className="text-[#095228] text-[12px] my-2 bg-[#EBF8ED] rounded-[20px] p-2">
                                          Cancle
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="flex flex-col">
                              {filteredGroups.length === 0 ? (
                                <p className="text-center text-gray-500 py-8">
                                  No groups found.
                                </p>
                              ) : (
                                filteredGroups.map((group) => (
                                  <button
                                    key={group.id}
                                    onClick={() => {
                                      setActiveUser(group);
                                      if (isMobile) setShowTabs(false);
                                    }}
                                    className={`tab-id-profile cursor-pointer my-4 mr-2 ${activeUser?.id === group.id ? "active gropfam-border" : ""
                                      }`}
                                  >
                                    <div className="swiper-groupsfollowers bg-white flex items-center p-1 cursor-pointer">
                                      <img
                                        src={group.group_image || userimg}
                                        alt={group.group_name}
                                        className="rounded-lg w-[92px] h-[102px] object-cover"
                                      />

                                      <div className="ml-2 flex-1">
                                        <div className="flex items-center justify-between">




                                          <div className="flex items-center mt-1 mb-2">

                                            <div className="flex flex-col flex-nowrap justify-between">
                                              <h4 className="text-base text-left font-semibold text-[#000000]">
                                                {group.group_name}
                                              </h4>
                                              <div className="flex ">
                                                {(group.followerImages ?? []).slice(0, 4).map((img, index) => (
                                                  <img
                                                    key={index}
                                                    src={img}
                                                    alt={`Follower ${index + 1}`}
                                                    className="w-6 h-6 rounded-full border-2 border-white"
                                                  />
                                                ))}

                                                <span className="text-xs text-[#000000] px-2 py-0.5 rounded-full ml-2 followers-user">
                                                  {group.acceptedMembersCount ?? 0} Members
                                                </span>
                                              </div>
                                              {group.myRole === "admin" && (
                                                <p className="text-[10px] flex items-center text-[#095228] font-medium">
                                                  <img src={verifybadge} className="!w-5 !h-5" />You are the Admin
                                                </p>
                                              )}
                                            </div>

                                          </div>

                                        </div>
                                        {/* ✅ Admin badge */}


                                      </div>
                                    </div>
                                  </button>
                                ))
                              )}
                            </div>

                          </div>
                        )}
                      </div>

                      {/* <div className="w-full"> */}

                      {/* {activeUser ? <GroupTabs user={activeUser} /> : <p className="p-4">Select a group to see details.</p>} */}

                      {/* CTA to Show Tabs Again */}
                      {!showTabs && isMobile && (
                        <button
                          onClick={() => setShowTabs(true)}
                          className="back-to-grps px-4 py-2 text-[#313131] text-[17px] font-semibold textrounded-lg mt-4 m-auto flex"
                        >
                          <img src={backtogrp} className="w-6 h-5 pr-3" />{" "}
                          <span className="hidden md:block">
                            Back to Groups
                          </span>
                        </button>
                      )}
                      {filteredGroups.length === 0 ? (
                        <p className="text-center text-gray-500 py-8">
                          No groups found.
                        </p>
                      ) : activeUser ? (
                        <GroupTabs
                          user={activeUser}
                          groupData={filteredGroups}
                          onGroupDelete={handleGroupDeleteFromList}
                          onViewGroupInfo={() => {
                            setShowTabs(false);
                            setShowDashboard(false); // ✅ hide dashboard
                          }}
                          showDashboard={showDashboard}
                          setShowDashboard={setShowDashboard}
                        />
                      ) : (
                        <p className="text-center">
                          Select a group to view details.
                        </p>
                      )}

                      {/* </div> */}
                    </div>
                  </div>

                  //   <div className="friend-requests">
                  //   {friendRequests.map((request) => (
                  //     <div key={request.id} className="friend-request">
                  //       <img src={request.img} alt={request.name} className="friend-img" />
                  //       <div>
                  //         <h3>{request.name}</h3>
                  //         <p>{request.followers} Followers</p>
                  //       </div>
                  //     </div>
                  //   ))}
                  // </div>
                )}
                {activeTab === "Family" && (
                  <div className="grp-tab-content grid ">
                    {/* Group Tabs (Left Sidebar) */}
                    <div className="grp-tab-content-flex grid grid-cols-[auto_1fr] gap-2 w-full ">
                      <div className="">
                        {(showTabs || !isMobile) && (
                          <div className="grop-tab ">
                            <div className="flex relative w-full mt-5">
                              <div className="fasearch">
                                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" />
                              </div>
                              <input
                                type="text"
                                placeholder="Find Your Family"
                                className="search-input focus:outline-none focus:ring-2 focus:ring-gray-300 text-[#000]"
                                value={groupSearch}
                                onChange={(e) => setGroupSearch(e.target.value)}
                              />
                            </div>
                            <div className="w-full flex justify-end block md:hidden py-5">
                              <button
                                class="w-full grp-crt-new-grp text-[16px] h-full rounded-[25px] mx-0"
                                onClick={createnewgroup}
                              >
                                <div className="w-full flex px-5 py-3 bg-[#ffffff9e] rounded-[25px]">
                                  <img
                                    src={Grpaddcircle}
                                    className="w-7 h-6 pr-1"
                                  />{" "}
                                  <span>Create New Group</span>
                                </div>
                              </button>
                            </div>

                            {isfamilyPopupOpen && (
                              <div className="popup-share z-[99999] viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
                                <div className="border-popup bg-white rounded-lg  relative">
                                  <div className="flex justify-between">
                                    <div className="logo-popup flex items-center justify-center space-x-2 ">
                                      <img
                                        src={pipaanlogo}
                                        alt="Pipaan Logo"
                                        className="w-50"
                                      />
                                    </div>
                                    {/* Close Button */}
                                    <button
                                      className="close-pop-x relative  text-gray-500"
                                      onClick={() =>
                                        CreatefamilyPopupOpen(false)
                                      }
                                    >
                                      {" "}
                                      <img
                                        src={closecircle}
                                        alt="Pipaan Logo"
                                        className="w-10 h-10"
                                      />
                                    </button>
                                  </div>
                                  <div className="max-w-3xl mx-auto p-4 crt-new-grp">
                                    <div className="flex flex-col items-center space-y-4">
                                      {/* Cover Photo */}
                                      <div className="relative pb-[100px]">
                                        <div className="cover-photo-newgrp relative w-[500px] md:w-[750px] h-[200px] bg-green-100 overflow-hidden">
                                          {coverPhoto ? (
                                            <img
                                              src={coverPhoto}
                                              alt="Cover Preview"
                                              className="w-full h-full object-cover"
                                            />
                                          ) : (
                                            <div className="flex justify-center items-center w-full h-full text-gray-500">
                                              Upload Cover Photo
                                            </div>
                                          )}
                                          <input
                                            type="file"
                                            accept="image/*"
                                            className="absolute inset-0 w-full h-auto opacity-0 cursor-pointer"
                                            onChange={
                                              handleCoverPhotoChangeFamily
                                            }
                                          />
                                        </div>

                                        {/* Profile Photo */}
                                        <div className=" top:20px md:right-[auto] absolute top-[130px] left-[30px] w-[150px] h-[150px] bg-green-300 rounded-[42px] overflow-hidden">
                                          {profilePhoto ? (
                                            <img
                                              src={profilePhoto}
                                              alt="Profile Preview"
                                              className="w-full h-full object-cover"
                                            />
                                          ) : (
                                            <div className="flex justify-center items-center w-full h-full text-gray-500">
                                              Upload Profile
                                            </div>
                                          )}
                                          <input
                                            type="file"
                                            accept="image/*"
                                            className="absolute inset-0 w-auto h-auto opacity-0 cursor-pointer"
                                            onChange={
                                              handleProfilePhotoChangeFamily
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="mb-4 text-left">
                                      <label className="block text-[#000000] font-medium mb-2">
                                        Family Name
                                      </label>
                                      <input
                                        type="text"
                                        value={familyFormData.name}
                                        onChange={(e) =>
                                          setFamilyFormData({
                                            ...familyFormData,
                                            name: e.target.value,
                                          })
                                        }
                                        placeholder="Enter Family Name"
                                        className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                      />
                                    </div>

                                    <div className="mb-4 text-left">
                                      <label className="block text-[#000000] font-medium mb-2">
                                        Family Info
                                      </label>
                                      <textarea
                                        value={familyFormData.info}
                                        onChange={(e) =>
                                          setFamilyFormData({
                                            ...familyFormData,
                                            info: e.target.value,
                                          })
                                        }
                                        placeholder="Enter family Info"
                                        className="w-full border border-[#095228] rounded-[12px] p-4 h-24 focus:outline-none focus:ring-2 focus:ring-green-500"
                                      />
                                    </div>
                                    <div className="mb-4 text-left">
                                      <label className="block text-[#000000] font-medium mb-2">
                                        Invite Friends
                                      </label>
                                      <input
                                        type="text"
                                        placeholder="Invite Friends"
                                        className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                        value={searchQuery}
                                        onChange={handleSearchChange} // Trigger search on input change
                                        onClick={() => {
                                          if (followers.length === 0)
                                            fetchFollowers(); // ✅ Fetch only if not already loaded
                                        }}
                                      />
                                      {followers.length > 0 && (
                                        <div className="bg-white border rounded shadow max-h-40 overflow-auto mt-2">
                                          {followers.map((friend) => (
                                            <div
                                              key={friend.id}
                                              className="cursor-pointer hover:bg-gray-100 px-4 py-2 flex items-center"
                                            >
                                              <div className="flex items-center">
                                                <img
                                                  src={
                                                    friend.profile_picture_url ||
                                                    userimg
                                                  } // Fallback to default image
                                                  alt={friend.first_name}
                                                  className="w-8 h-8 rounded-full mr-3"
                                                />
                                                <div>
                                                  <p className="font-medium">
                                                    {friend.first_name}{" "}
                                                    {friend.last_name}
                                                  </p>
                                                  <p className="text-sm text-gray-500">
                                                    @{friend.username}
                                                  </p>
                                                </div>
                                              </div>
                                              {/* ✅ Now inside the map, friend is defined */}
                                              <button
                                                onClick={() =>
                                                  handleFriendSelect(friend)
                                                }
                                                className="text-sm bg-[#095228] text-white px-3 py-1 rounded-full ml-2 hover:bg-green-700"
                                              >
                                                Add As Group Member
                                              </button>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div>

                                    <div className="flex relative w-full ">
                                      <div className="fasearch">
                                        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" />
                                      </div>
                                      <input
                                        type="text"
                                        placeholder="Find Group Members"
                                        className="search-input focus:outline-none focus:ring-2 focus:ring-[#e5e7eb] bg-[#FFFFFF]"
                                      />
                                    </div>
                                    {selectedFriends.map((friend) => (
                                      <div
                                        key={friend.id}
                                        className="followers followers-friends-profile followers-responsive justify-between border-b-0 border-[#fff] pb-6 flex flex-wrap md:flex-nowrap"
                                      >
                                        <div className="flex w-full">
                                          <div className="flex w-full">
                                            <img
                                              src={
                                                friend.profile_picture_url ||
                                                userimg
                                              }
                                              alt="User"
                                              className="w-15 h-15 rounded-full"
                                            />
                                            <div className="pl-4 w-full">
                                              <div className="flex items-center ">
                                                <p className="titlesemibold pb-1 pr-5">
                                                  {friend.first_name}{" "}
                                                  {friend.last_name}
                                                </p>
                                                <p className="suggest-profile cursor-pointer text-[10px] text-[#095228] mt-1 flex items-center">
                                                  <img
                                                    src={Verify}
                                                    className="w-fit h-fit"
                                                  />
                                                  <span>Member</span>
                                                </p>
                                              </div>
                                              <p className="text-[12px] text-[#747474] pb-1 text-left">
                                                @{friend.username}
                                              </p>
                                              <p className="members">
                                                {friend.followers || 0}{" "}
                                                Followers{" "}
                                                <span className="text-[#D9D9D9] px-2">
                                                  |
                                                </span>{" "}
                                                <span className="italic text-[#095228b8] text-[10px] underline">
                                                  {friend.mutual_followers || 0}{" "}
                                                  Mutual Followers
                                                </span>
                                              </p>
                                            </div>
                                          </div>
                                          <div className="flex follow-unfollow-cta justify-end w-full">
                                            <button
                                              className="text-[#095228] text-[12px] my-2 bg-[#EBF8ED] rounded-[20px] p-2"
                                              onClick={() => {
                                                setSelectedFriends((prev) =>
                                                  prev.filter(
                                                    (f) => f.id !== friend.id
                                                  )
                                                );
                                                setGroupMembers((prev) =>
                                                  prev.filter(
                                                    (id) => id !== friend.id
                                                  )
                                                );
                                              }}
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                    <div className=" followers followers-friends-profile followers-responsive justify-between border-b-0 border-[#fff] pb-6 ">
                                      <div className="flex follow-unfollow-cta justify-end w-full">
                                        <div className="flex gap-4 mt-4">
                                          <button
                                            onClick={handleCreateFamily}
                                            disabled={isSubmitting}
                                            className="bg-[#095228] text-white text-sm rounded-[20px] px-6 py-2 min-w-[140px] text-center"
                                          >
                                            {isSubmitting
                                              ? "Creating..."
                                              : "Create Family"}
                                          </button>

                                          <button
                                            onClick={() =>
                                              CreatefamilyPopupOpen(false)
                                            }
                                            className="text-[#095228] text-sm bg-[#EBF8ED] rounded-[20px] px-6 py-2 min-w-[140px] text-center"
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="flex flex-col">
                              {filteredFamily.length === 0 ? (
                                <p className="text-center text-gray-500 py-8">
                                  No groups found.
                                </p>
                              ) : (
                                filteredFamily.map((group) => (
                                  <button
                                    key={group.id}
                                    onClick={() => {
                                      setActiveUser(group);
                                      if (isMobile) setShowTabs(false);
                                    }}
                                    className={`tab-id-profile cursor-pointer my-4 mr-2 ${activeUser?.id === group.id
                                      ? "gropfam-border"
                                      : ""
                                      }`}
                                  >
                                    <div
                                      className={`swiper-groupsfollowers bg-white flex items-center p-1 cursor-pointer`}
                                    >
                                      <img
                                        src={group.group_image || userimg}
                                        alt={group.group_name}
                                        className="rounded-lg w-[92px] h-[102px] object-cover"
                                      />
                                      <div className="ml-2 flex-1">
                                        <h4 className="text-base text-left font-semibold">
                                          <span className="px-1 rounded text-[#000000]">
                                            {group.group_name}
                                          </span>
                                        </h4>
                                        <div className="flex items-center mt-1 mb-2">
                                          <div className="flex -space-x-1">
                                            {(group.followerImages ?? [])
                                              .slice(0, 4)
                                              .map((img, index) => (
                                                <img
                                                  key={index}
                                                  src={img}
                                                  alt={`Follower ${index + 1}`}
                                                  className="w-6 h-6 rounded-full border-2 border-white"
                                                />
                                              ))}
                                          </div>
                                          <span className="text-xs text-[#000000] px-2 py-0.5 rounded-full ml-2 followers-user">
                                            {group.acceptedMembersCount ?? 0}{" "}
                                            Members
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </button>
                                ))
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="w-full">
                        {/* {activeUser ? <GroupTabs user={activeUser} /> : <p className="p-4">Select a group to see details.</p>} */}

                        {/* CTA to Show Tabs Again */}
                        {!showTabs && isMobile && (
                          <button
                            onClick={() => setShowTabs(true)}
                            className="back-to-grps px-4 py-2 text-[#313131] text-[17px] font-semibold textrounded-lg mt-4 m-auto flex"
                          >
                            <img src={backtogrp} className="w-6 h-5 pr-3" />{" "}
                            <span className="hidden md:block">
                              Back to Groups
                            </span>
                          </button>
                        )}
                        {filteredFamily.length === 0 ? (
                          <p className="text-center text-gray-500 py-8">
                            No groups found.
                          </p>
                        ) : activeUser ? (
                          <GroupTabs
                            user={activeUser}
                            groupData={filteredFamily}
                            onGroupDelete={handleGroupDeleteFromList}
                            onViewGroupInfo={() => setShowTabs(false)}
                          />
                        ) : (
                          <p className="text-center">
                            Select a group to view details.
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  // <div className="friends-tab">
                  //   <div className="flex relative w-full">
                  //     <div className="fasearch">
                  //       <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" />
                  //     </div>
                  //     <input
                  //       type="text"
                  //       placeholder="Find Your Friend"
                  //       value={familySearch}
                  //       onChange={e => setFamilySearch(e.target.value)}

                  //       className="search-input focus:outline-none focus:ring-2 focus:ring-gray-300 text-[#000]"
                  //     />
                  //   </div>
                  //   <div className="w-full flex justify-end block md:hidden py-5">
                  //     <button class="w-full grp-crt-new-grp text-[16px] h-full rounded-[25px] mx-0 " onClick={createnewgroup}><div className="w-full flex px-5 py-3 bg-[#ffffff9e] rounded-[25px]"><img src={Grpaddcircle} className="w-7 h-6 pr-1" /> <span>Create New Group</span></div></button>

                  //   </div>

                  //   {followersList
                  //     .filter(user =>
                  //       !familySearch.trim() ||
                  //       (user.name && user.name.toLowerCase().includes(familySearch.toLowerCase())) ||
                  //       (user.username && user.username.toLowerCase().includes(familySearch.toLowerCase()))
                  //     )
                  //     .map((user, index) => (
                  //       <div
                  //         key={index}
                  //         className="followers followers-friends-profile justify-between border-b-2 border-[#161f2833] pb-6"
                  //       >
                  //         <div className="flex">
                  //           <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                  //           <div className="pl-4">
                  //             <p className="titlesemibold pb-1">{user.name || "Marketing Group"}</p>
                  //             <p className="text-[12px] text-[#747474] pb-1">@{user.username || "prvnk_sky"}</p>
                  //             <p className="members">
                  //               {user.followers || 764} Followers <span className="text-[#D9D9D9] px-1">|</span>
                  //             </p>
                  //           </div>
                  //         </div>
                  //         <div className="flex follow-unfollow-cta">
                  //           <button className="follow-cta my-2">Unfollow</button>
                  //           <button className="follow-cta-block my-2">Block</button>
                  //         </div>
                  //       </div>
                  //     ))}

                  // </div>
                )}
              </div>
            </div>
            <div className="md:hidden">
              <p className="text-[#095228] text-[16px] text-center">
                © 2025 <b>Pipaan</b>. All Rights Reserved
              </p>
            </div>
          </div>
          {isPopupOpen && (
            <div className="popup-share z-[99999] viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
              <div className="border-popup bg-white rounded-lg  relative">
                <div className="flex justify-between">
                  <div className="logo-popup flex items-center justify-center space-x-2 ">
                    <img src={pipaanlogo} alt="Pipaan Logo" className="w-50" />
                  </div>
                  {/* Close Button */}
                  <button
                    className="close-pop-x relative  text-gray-500"
                    onClick={() => CreatePopupOpen(false)}
                  >
                    {" "}
                    <img
                      src={closecircle}
                      alt="Pipaan Logo"
                      className="w-10 h-10"
                    />
                  </button>
                </div>
                <div className="max-w-3xl mx-auto p-4 crt-new-grp">
                  <div className="flex flex-col items-center space-y-4">
                    {/* Cover Photo */}
                    <div className="relative pb-[100px]">
                      <div className="cover-photo-newgrp relative w-[500px] md:w-[750px] h-[200px] bg-green-100 overflow-hidden">
                        {groupCover ? (
                          <img
                            src={groupCover}
                            alt="Cover Preview"
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="flex justify-center items-center w-full h-full text-gray-500">
                            Upload Cover Photo
                          </div>
                        )}
                        <input
                          type="file"
                          accept="image/*"
                          className="absolute inset-0 w-full h-auto opacity-0 cursor-pointer"
                          onChange={handleGroupCoverUpload}
                        />
                      </div>

                      {/* Profile Photo */}
                      <div className=" top:20px md:right-[auto] absolute top-[130px] left-[30px] w-[150px] h-[150px] bg-green-300 rounded-[42px] overflow-hidden">
                        {groupImage ? (
                          <img
                            src={groupImage}
                            alt="Profile Preview"
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="flex justify-center items-center w-full h-full text-gray-500">
                            Upload Profile
                          </div>
                        )}
                        <input
                          type="file"
                          accept="image/*"
                          className="absolute inset-0 w-auto h-auto opacity-0 cursor-pointer"
                          onChange={handleGroupImageUpload}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-4 text-left">
                    <label className="block text-[#000000] font-medium mb-2">
                      Group Name
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Group Name"
                      className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                      value={groupName}
                      onChange={(e) => setGroupName(e.target.value)}
                    />
                  </div>

                  <div className="mb-4 text-left">
                    <label className="block text-[#000000] font-medium mb-2">
                      Group Info
                    </label>
                    <textarea
                      placeholder="Enter Group Name"
                      className="w-full border border-[#095228] rounded-[12px] p-4 h-24 focus:outline-none focus:ring-2 focus:ring-green-500"
                      value={groupDescription}
                      onChange={(e) => setGroupDescription(e.target.value)}
                    />
                  </div>
                  <div className="mb-4 text-left">
                    <label className="block text-[#000000] font-medium mb-2">
                      Invite Friends
                    </label>
                    <input
                      type="text"
                      placeholder="Invite Friends"
                      className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                      value={searchQuery}
                      onChange={handleSearchChange} // Trigger search on input change
                      onClick={() => {
                        if (followers.length === 0) fetchFollowers(); // ✅ Fetch only if not already loaded
                      }}
                    />
                    {/* Search Results Dropdown */}
                    {followers.length > 0 && (
                      <div className="bg-white border rounded shadow max-h-40 overflow-auto mt-2">
                        {followers.map((friend) => (
                          <div
                            key={friend.id}
                            className="cursor-pointer hover:bg-gray-100 px-4 py-2 flex items-center justify-between"
                          >
                            <div className="flex items-center ">
                              <img
                                src={friend.profile_picture_url || userimg} // Fallback to default image
                                alt={friend.first_name}
                                className="w-8 h-8 rounded-full mr-3"
                              />
                              <div>
                                <p className="font-medium">
                                  {friend.first_name} {friend.last_name}
                                </p>
                                <p className="text-sm text-gray-500">
                                  @{friend.username}
                                </p>
                              </div>
                            </div>
                            {/* ✅ Now inside the map, friend is defined */}
                            <button
                              onClick={() => handleFriendSelect(friend)}
                              className="text-sm bg-[#095228] text-white px-3 py-1 rounded-full ml-2 hover:bg-green-700"
                            >
                              Add As Group Member
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Selected Friends */}
                    {/* {selectedFriends.length > 0 && (
                      <div className="mt-4">
                        <p className="font-medium mb-2">Selected Friends:</p>
                        <div className="flex flex-wrap gap-2">
                          {selectedFriends.map((friend) => (
                            <div
                              key={friend.id}
                              className="bg-green-100 text-green-700 px-3 py-1 rounded-full flex items-center"
                            >
                              {friend.first_name} {friend.last_name}
                              <button
                                className="ml-2 text-red-500"
                                onClick={() => {
                                  setSelectedFriends((prev) => prev.filter((f) => f.id !== friend.id));
                                  setGroupMembers((prev) => prev.filter((id) => id !== friend.id)); // Remove from group members
                                }}
                              >
                                ✖
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )} */}
                  </div>
                  <div className="followers followers-friends-profile followers-responsive flex flex-col space-y-4 pb-6 border-b border-[#161f283d]">
                    {/* {selectedFriends.map((friend) => (
                      <div key={friend.id} className="flex w-full">
                        <img src={friend.profile_picture_url || userimg} alt="User" className="w-15 h-15 rounded-full" />
                        <div className="pl-4 w-full">
                          <div className="flex items-center justify-between">
                            <p className="titlesemibold pb-1 pr-5">{friend.first_name} {friend.last_name}</p>
                          </div>
                          <p className="text-[12px] text-[#747474] pb-1">@{friend.username}</p>
                          <p className="members">{friend.followers || 0} Followers <span className="text-[#D9D9D9] px-1">|</span></p>
                        </div>
                      </div>
                    ))} */}

                    <div className="flex items-center space-x-4 w-full  justify-between  flex-row-reverse  md:flex-row mt-3">
                      {/* Custom Checkbox */}
                      {/* <label className="flex items-center space-x-2 cursor-pointer ">
                        <div
                          className={`w-4 h-4 border-2 rounded-md flex justify-center items-center transition ${isAdmin ? "border-[#095228] bg-green-100" : "border-gray-400"
                            }`}
                          onClick={() => setIsAdmin(!isAdmin)}
                        >
                          {isAdmin && <Check size={18} className="text-[#095228]" />}
                        </div>
                        <span className="text-[#344054] text-[12px]">Mark as Admin</span>
                      </label> */}

                      {/* <div className="flex follow-unfollow-cta justify-end ">
                        <button className="follow-cta my-2">Add as Group Member</button>
                      </div> */}
                    </div>
                  </div>
                  {/* <div className="flex relative w-full ">
                    <div className="fasearch">
                      <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" />
                    </div>
                    <input
                      type="text"
                      placeholder="Find Group Members"
                      className="search-input focus:outline-none focus:ring-2 focus:ring-[#e5e7eb] bg-[#FFFFFF]"
                    />
                  </div> */}
                  {/* <div className=" followers followers-friends-profile followers-responsive justify-between border-b-0 border-[#fff] pb-6 ">
                    <div className="flex w-full">
                      <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                      <div className="pl-4 w-full">
                        <div className="flex items-center ">
                          <p className="titlesemibold pb-1 pr-5">Marketing Group</p>
                          <p className="cursor-pointer text-[10px] text-[#095228] mt-1 flex items-center">
                            <img src={Verify} className="w-fit h-fit" />
                            <span>Admin</span>
                          </p>
                        </div>
                        <p className="text-[12px] text-[#747474] pb-1">
                          @prvnk_sky
                        </p>
                        <p className="members">764 Followers <span className="text-[#D9D9D9] px-1">|</span> <span className="italic text-[#095228b8] text-[10px] underline">4 Mutual Followers</span></p>
                      </div>

                    </div>
                    <div className="flex follow-unfollow-cta justify-end w-full">
                      <button className="text-[#095228] text-[12px] my-2 bg-[#EBF8ED] rounded-[20px] p-2">Cancel</button>
                    </div>
                  </div> */}

                  {selectedFriends.map((friend) => (
                    <div
                      key={friend.id}
                      className="followers followers-friends-profile followers-responsive justify-between border-b-0 border-[#fff] pb-6 flex flex-wrap md:flex-nowrap"
                    >
                      <div className="flex w-full">
                        <div className="flex w-full items-center">
                          <img
                            src={friend.profile_picture_url || userimg}
                            alt="User"
                            className="w-15 h-15 rounded-full"
                          />
                          <div className="pl-4 w-full">
                            <div className="flex items-center ">
                              <p className="titlesemibold pb-1 pr-5">
                                {friend.first_name} {friend.last_name}
                              </p>
                              <p className="cursor-pointer text-[10px] text-[#095228] mt-1 flex items-center">
                                <img src={Verify} className="w-fit h-fit" />
                                <span>Member</span>
                              </p>
                            </div>
                            <p className="text-[12px] text-[#747474] pb-1 text-left">
                              @{friend.username}
                            </p>
                            <p className="members">
                              {friend.followers || 0} Followers{" "}
                              <span className="text-[#D9D9D9] px-2">|</span>{" "}
                              <span className="italic text-[#095228b8] text-[10px] underline">
                                {friend.mutual_followers || 0} Mutual Followers
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="flex follow-unfollow-cta justify-end w-full">
                          <button
                            className="text-[#095228] h-max text-[12px] my-2 bg-[#EBF8ED] rounded-[20px] p-2"
                            onClick={() => {
                              setSelectedFriends((prev) =>
                                prev.filter((f) => f.id !== friend.id)
                              );
                              setGroupMembers((prev) =>
                                prev.filter((id) => id !== friend.id)
                              );
                            }}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Create Group Button */}
                  <div className="flex justify-end">
                    <button
                      className="follow-cta my-2 bg-[#095228] text-white px-4 py-2 rounded-full"
                      onClick={handleCreateGroup}
                      disabled={loading}
                    >
                      {loading ? "Creating..." : "Create Group"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Right Sidebar */}
          {/* <Rightsidebar /> */}
        </main>
      </main>
    </div>
  );
}
